module.exports = __webpack_public_path__ + "img/gate_failed_badge.513ffcc.svg";